import React, { Component } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Button,
  UncontrolledAlert
} from "reactstrap";
import DataTable from "../../../Shared/DataTable";

import { MdArrowBack } from "react-icons/md";
import { AdminEvents } from "../../../../_constants/RouteVariables";
import { NavLink } from "react-router-dom";

export class EventsAttendeesTable extends Component {
  state = {
    status: "all"
  };

  changeValue = event => {
    this.setState({ status: event.target.value });

    this.props.filterData({
      status: event.target.value !== "all" ? event.target.value : ""
    });
  };

  render() {
    const columns = [
      {
        Header: "First Name",
        accessor: "firstName",
        
        Filter: ({ filter, onChange }) => (
          <input
            onChange={event => onChange(event.target.value)}
            value={filter ? filter.value : ""}
            placeholder="&#x1F50D;"
            style={{
              width: "100%"
            }}
          />
        )
      },
      {
        Header: "Last Name",
        accessor: "lastName"
      },
      {
        Header: "Email",
        accessor: "email",

        Filter: ({ filter, onChange }) => (
          <input
            onChange={event => onChange(event.target.value)}
            value={filter ? filter.value : ""}
            placeholder="&#x1F50D;"
            style={{
              width: "100%"
            }}
          />
        )
      },
      {
        Header: "Phone Number",
        accessor: "phoneNumber",

        Filter: ({ filter, onChange }) => (
          <input
            onChange={event => onChange(event.target.value)}
            value={filter ? filter.value : ""}
            placeholder="&#x1F50D;"
            style={{
              width: "100%"
            }}
          />
        )
      },
      {
        Header: "Gender",
        accessor: "gender",
        maxWidth: 100,
        Cell: row => (
          <span>{row.value === "M" ? <p>Male</p> : <p>Female</p>}</span>
        )
      }
    ];

    const {
      match,
      fetching,
      data,
      error,
      selectRow,
      pages,
      page,
      pageSize,
      setPageNumber,
      filterData,
      setPageSize,
      eventName
    } = this.props;

    return (
      <div>
        <NavLink to={AdminEvents}>
          <Button type="button" color="primary" className="mb-2">
            <MdArrowBack />
            <span>Back</span>
          </Button>
        </NavLink>
        <Card>
          <CardHeader>{eventName}</CardHeader>
          <CardBody>
            {error && (
              <UncontrolledAlert color="danger">
                {error.message}
              </UncontrolledAlert>
            )}

            <DataTable
              columns={columns}
              loading={fetching}
              urlParams={match}
              data={data ? data.content : []}
              count={data ? data.count : 0}
              defaultPageSize={5}
              selectRow={selectRow}
              manual={true}
              pages={pages}
              page={page}
              pageSize={pageSize}
              showInstructorActions={false}
              filterData={filterData}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
              hideSearchParam={true}
              searchParam="searchKey"
              searchPlaceholder="Search by title/instructor"
              hideActions={true}
              countTitle="Attendee(s)"
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default EventsAttendeesTable;
